import React from 'react';
import styles from './index.css';
class Copyright extends React.PureComponent {
    render() {
        const { content } = this.props;
        const date = new Date();
        const year = date.getFullYear();
        const txt = `Copyright © ${year} Phoenix New Media Limited All Rights Reserved.`;
        const txt2 = (content && content.text) || '';
        const url = (content && content.url) || '';
        return (React.createElement("div", { className: styles.box },
            txt2 && React.createElement("div", { className: styles.twoLine },
                React.createElement("a", { href: url }, txt2)),
            React.createElement("div", { className: styles.oneLine }, txt)));
    }
}
export default Copyright;
